import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Helmet } from 'react-helmet';
import OracleTable from './OracleTable';
import XIcon from '../lib/XIcon';
import IntegrationGuide from '../common/IntegrationGuide';
import SponsorContainer from '../sponsorship/SponsorContainer';
// import TextAd from '../sponsorship/TextAd';

const OracleIndex = (props) => {
    return (
        <div>
            <Helmet>
                <title>Price Oracles | XRPSCAN</title>
            </Helmet>
            <Row>
                <Col>
                    <IntegrationGuide/>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <SponsorContainer />
                </Col>
            </Row>
            {/* <Row>
                <Col xs={12} md={12}>
                    <TextAd/>
                </Col>
            </Row> */}
            <Row>
                <Col xs={12} md={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title>
                                <XIcon icon='money-check-dollar' />
                                <span className="pl-2">Price Oracles</span>
                            </Card.Title>
                            <OracleTable/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default OracleIndex;